(function (process){
var pull = require('pull-core');
var ready = require('./ready');

/**
  ### `sink(socket, opts?)`

  Create a pull-stream `Sink` that will write data to the `socket`.

  <<< examples/write.js

**/
module.exports = pull.Sink(function(read, socket, opts) {
  opts = opts || {}
  var closeOnEnd = opts.closeOnEnd !== false;
  var onClose = 'function' === typeof opts ? opts : opts.onClose;

  function next(end, data) {
    // if the stream has ended, simply return
    if (end) {
      if (closeOnEnd && socket.readyState <= 1) {
        if(onClose)
          socket.addEventListener('close', function (ev) {
            if(ev.wasClean) onClose()
            else {
              var err = new Error('ws error')
              err.event = ev
              onClose(err)
            }
          });

        socket.close();
      }

      return;
    }

    // socket ready?
    ready(socket, function(end) {
      if (end) {
        return read(end, function () {});
      }

      socket.send(data);
      process.nextTick(function() {
        read(null, next);
      });
    });
  }

  read(null, next);
});

}).call(this,require('_process'))
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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